"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    httpError: {
        title: 'Oh, snap!',
        message: 'Server request is unsuccessful.',
    },
};
